import { Gtm } from "../apis/gtm";

export class UiController {
  static init = () => {
    const appButtons = document.querySelectorAll('a[data-cb-id]');

    appButtons.forEach(btn => {
      const attr = btn.getAttribute('data-cb-id');
      if (attr === 'apple') {
        btn.addEventListener('click', () => {
          Gtm.trackAppLinkClick('apple');
        });
      }
      if (attr === 'google') {
        btn.addEventListener('click', () => {
          Gtm.trackAppLinkClick('google');
        });
      }
    });
  }
}
